import { Container, Navbar, Nav, NavDropdown, Image, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';

const menuItems = [
  {
    title: 'HOME',
    items: [
      { label: 'WELCOME', href: '/#welcome' },
      { label: 'IMPORTANT DATES', href: '/#important-dates' },
      { label: 'ORGANIZERS', href: '/#organizers' },
    ],
  },
  {
    title: 'PARTICIPATE',
    items: [
      { label: 'ABSTRACT SUBMISSION', disabled: true },
      { label: 'REGISTRATION', disabled: true },
    ],
  },
  {
    title: 'CONFERENCE INFO',
    items: [
      { label: 'TOPICS and SPECIAL SESSIONS', to: '/topics-and-special-sessions' },
      { label: 'PLENARIES and KEYNOTES', disabled: true },
      { label: 'TENTATIVE PROGRAMME', to: '/tentative-program' },
      { label: 'INSTRUCTIONS FOR PRESENTERS', disabled: true },
      { label: 'COMMUNITY MEETINGS', to: '/community-meetings' },
      { label: 'AWARDS', to: '/awards' },
      { label: 'WORKSHOPS', disabled: true },
      { label: 'SCIENTIFIC EXCURSIONS', disabled: true },
      { label: 'YIN', disabled: true },
      { label: 'COMMITTEES', to: '/committees' },
      { label: 'CONTACTS', to: '/contacts' },
      { label: 'PROCEEDINGS', disabled: true },
    ],
  },
  
  {
    title: 'PARTICIPANT INFO',
    items: [
      { label: 'LOCATION', to: '/location' },
      { label: 'VENUE', to: '/venue' },
      { label: 'ACCOMMODATION', to: '/accommodation' },
      { label: 'TRAVEL', to: '/travel' },
      { label: 'VISA', to: '/visa' },
      { label: 'SOCIAL EVENTS', to: '/social-events' },
    ],
  },
];

export default function Navigation() {
  const [navbarScrolled, setNavbarScrolled] = useState(false);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setNavbarScrolled(window.scrollY > 50);
    };

    handleScroll();

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const closeMobileMenu = () => {
    setExpanded(false);
  };

  const renderDropdownItem = (dropdownItem) => {
    if (dropdownItem.disabled) {
      return (
        <NavDropdown.Item key={dropdownItem.label} disabled>
          {dropdownItem.label}
        </NavDropdown.Item>
      );
    }

    if (dropdownItem.to) {
      return (
        <NavDropdown.Item
          key={dropdownItem.to}
          as={Link}
          to={dropdownItem.to}
          onClick={closeMobileMenu}
        >
          {dropdownItem.label}
        </NavDropdown.Item>
      );
    }

    return (
      <NavDropdown.Item
        key={dropdownItem.href}
        href={dropdownItem.href}
        onClick={closeMobileMenu}
      >
        {dropdownItem.label}
      </NavDropdown.Item>
    );
  };

  return (
    <Navbar
      variant="dark"
      expand="xl"
      fixed="top"
      expanded={expanded}
      onToggle={setExpanded}
      className={`eac-dropdown-navbar ${navbarScrolled ? 'navbar-scrolled' : ''}`}
    >
      <Container>
        <Navbar.Brand as={Link} to="/" aria-label="EAC 2027 home" onClick={closeMobileMenu}>
          <Image src="/eac2027light.svg" height="40px" alt="EAC 2027" />
        </Navbar.Brand>

        <Navbar.Toggle
          aria-controls="main-navbar-nav"
          className={`hamburger hamburger--squeeze eac-hamburger-toggler ${expanded ? 'is-active' : ''}`}
        >
          <span className="hamburger-box">
            <span className="hamburger-inner"></span>
          </span>
        </Navbar.Toggle>

        <Navbar.Collapse id="main-navbar-nav">
          <Nav className="ms-auto ">
            {menuItems.map((menuItem) => (
              <NavDropdown
                key={menuItem.title}
                title={menuItem.title}
                id={`nav-dropdown-${menuItem.title.toLowerCase().replace(/\s+/g, '-')}`}
                className="eac-nav-dropdown"
              >
                {menuItem.items.map(renderDropdownItem)}
              </NavDropdown>
            ))}

            <Nav.Link className='disabled' as={Link} to="" onClick={closeMobileMenu}>
              PROGRAMME
            </Nav.Link>

            <Nav.Link as={Link} to="/sponsors" onClick={closeMobileMenu}>
              SPONSORS
            </Nav.Link>

            <OverlayTrigger
              placement="bottom"
              overlay={
                <Tooltip id="linkedin-tooltip">
                  Our Linkedin
                </Tooltip>
              }
            >
            <Nav.Link
              href="https://www.linkedin.com/showcase/eac2027/posts/?feedView=all"
              target="_blank"
              rel="noreferrer"
              className="nav-linkedin ms-lg-3_"
              aria-label="Newsletter"
            >
              <i className="bi bi-linkedin" aria-hidden="true"></i>
            </Nav.Link>
            </OverlayTrigger>

            <OverlayTrigger
              placement="bottom"
              overlay={
                <Tooltip id="newsletter-tooltip">
                  Our newsletter
                </Tooltip>
              }
            >
              <Nav.Link
                href="https://756b0975.sibforms.com/serve/MUIFAExUQ8BuBk-bI00pY3aLy2xdqWMPTqdQsszRekzMjGyX0LQC9Qnf31TB64baa4HXabH_vi6MjgOfuR0V8HaAk4eorGuSFw0x5lPeqZwDNmz7tNipgsYfh5OYS9DlHjvWkPVvCoY4G_hJQrd1tZe9XmMr2DeNxadBQyFd5F4xNYFi_RUMc5eqoZtkw6vh_pO3HCbPVlLTTkOR"
                target="_blank"
                rel="noreferrer"
                className="nav-linkedin ms-lg-3_"
                aria-label="Subscribe to the EAC2027 newsletter"
              >
                <i className="bi bi-envelope-paper" aria-hidden="true"></i>
              </Nav.Link>
            </OverlayTrigger>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
